export const APP_SERVICE_WORKER_PATH = "/sw.js";

export interface ServiceWorkerRegistrar {
  register(
    scriptURL: string | URL,
    options?: RegistrationOptions,
  ): Promise<ServiceWorkerRegistration>;
}

export interface ServiceWorkerRegistrationOptions {
  navigatorLike?: { serviceWorker?: ServiceWorkerRegistrar };
  secureContext?: boolean;
}

/**
 * Registers the versioned app-shell worker. The caller owns update UI and may
 * safely call this more than once; browsers coalesce registrations by scope.
 */
export async function registerAppServiceWorker(
  options: ServiceWorkerRegistrationOptions = {},
): Promise<ServiceWorkerRegistration | null> {
  const navigatorLike = options.navigatorLike
    ?? (typeof navigator === "undefined" ? undefined : navigator);
  const secureContext = options.secureContext
    ?? (typeof window !== "undefined" && window.isSecureContext);
  if (!navigatorLike?.serviceWorker || !secureContext) return null;
  return navigatorLike.serviceWorker.register(APP_SERVICE_WORKER_PATH, {
    scope: "/",
    updateViaCache: "none",
  });
}
